// NATIVE

// INSTALLED

// CUSTOM
import { checkingPreload, unCheckingPreload } from '../loading';
import {
  getAllServicesIaCreditTransactions,
  getServicesIaCreditTransactionById,
} from '../../services/services-ia-credit-transactions.service';
import {
  setServicesIaCreditTransactionsListRedux,
  setServicesIaCreditTransactionActiveRedux,
} from './servicesIaCreditTransactionsSlice';
import { QueryPagination } from '../../commons/interfaces';

export const getAllServicesIaCreditTransactionsStore =
  (query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response: any = await getAllServicesIaCreditTransactions(query);

      if (response.ok) {
        await dispatch(setServicesIaCreditTransactionsListRedux(response.data));
      }

      return response;
    } catch (error) {
      console.error(error);

      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const getServicesIaCreditTransactionByIdStore = (id: string) => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response: any = await getServicesIaCreditTransactionById(id);

    if (response.ok) {
      dispatch(setServicesIaCreditTransactionActiveRedux(response.data));
    }

    return response;
  } catch (error) {
    console.error(error);

    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};
